portal-loader {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

portal-loader .animated-path {
  stroke: #0a66d7;
  stroke-width: 32;
  stroke-dasharray: 672 672;
  stroke-dashoffset: 672;
  animation: dash 7s linear infinite;
}

@keyframes dash {
  12.5% {
    stroke: #fa4b16;
  }
  25% {
    stroke: #fa4b16;
    stroke-dashoffset: -672;
    stroke-width: 32.01; /* this is the only way for the animation to work in Edge */
  }
  25.01% {
    stroke-dashoffset: 672;
    stroke-width: 32;
  }
  37.5% {
    stroke: #f7b612;
  }
  50% {
    stroke: #f7b612;
    stroke-dashoffset: -672;
    stroke-width: 32.01;
  }
  50.01% {
    stroke-dashoffset: 672;
    stroke-width: 32;
  }
  62.5% {
    stroke: #32d96e;
  }
  75% {
    stroke: #32d96e;
    stroke-dashoffset: -672;
    stroke-width: 32.01;
  }
  75.01% {
    stroke-dashoffset: 672;
    stroke-width: 32;
  }
  87.5% {
    stroke: #0a66d7;
  }
  100% {
    stroke-dashoffset: -672;
    stroke-width: 32.01;
  }
}
